import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import CollectionSetting from './components/CollectionSetting';

const CollectingMemberInfoSetting = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="會員個資蒐集設定"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '會員個資蒐集設定',
            },
          ]}
        />
        <CollectionSetting />
      </Col>
    </Row>
  );
};

export default CollectingMemberInfoSetting;
